var tagRegex = /^\s*<\/?[^>]+>\s*$/;
var tagWordRegex = /<[^\s>]+/;
var whitespaceRegex = /^(\s|&nbsp;)+$/;
var wordRegex = /[\w\#@]+/;
var specialCaseWordTags = ['<img'];

function isTag(item) {
  if (specialCaseWordTags.some(function (re) {
    return item !== null && item.startsWith(re);
  })) {
    return false;
  }

  return tagRegex.test(item);
}

function stripTagAttributes(word) {
  var tag = tagWordRegex.exec(word)[0];
  word = tag + (word.endsWith("/>") ? "/>" : ">");
  return word;
}

function wrapText(text, tagName, cssClass) {
  return ['<', tagName, ' class="', cssClass, '">', text, '</', tagName, '>'].join('');
}

function isStartOfTag(val) {
  return val === '<';
}

function isEndOfTag(val) {
  return val === '>';
}

function isStartOfEntity(val) {
  return val === '&';
}

function isEndOfEntity(val) {
  return val === ';';
}

function isWhiteSpace(value) {
  return whitespaceRegex.test(value);
}

function stripAnyAttributes(word) {
  if (isTag(word)) {
    return stripTagAttributes(word);
  }

  return word;
}

function isWord(text) {
  return wordRegex.test(text);
}

export { isTag, stripTagAttributes, wrapText, isStartOfTag, isEndOfTag, isStartOfEntity, isEndOfEntity, isWhiteSpace, stripAnyAttributes, isWord };